import { Namespace, ParseKeys } from 'i18next';
import { Trans, useTranslation } from 'react-i18next';
import { ButtonTertiaryOnLightM, ButtonTertiaryOnLightMProps } from '@steelbuy/ui-primitive';
import './ToastReminder.scss';

type ToastReminderProps = {
    i18nKey: ParseKeys<Namespace, object, undefined>;
    cta: ButtonTertiaryOnLightMProps;
};

export const ToastReminder = ({ i18nKey, cta }: ToastReminderProps) => {
    const { t } = useTranslation('translation');
    return (
        <div className="toast-reminder">
            <div className="toast-reminder--message">
                <Trans i18nKey={i18nKey as keyof typeof useTranslation} t={t} />
            </div>
            <ButtonTertiaryOnLightM {...cta} />
        </div>
    );
};
